import React from 'react';
import './mypro.css';

const ResponsiveMobile = () => {
  return (
    <div>welcome to responsive menu project</div>
  );
};

export default ResponsiveMobile;
